var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticStyle:{"height":"60px"}}),_c('van-tabbar',{attrs:{"value":_vm.active},on:{"change":_vm.change}},[_c('van-tabbar-item',{attrs:{"icon":"home-o","name":"/home"}},[_vm._v("首页")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }